import {
  DISPLAY_CONTEXT_ASSISTANT_MESSAGE,
  HIDE_CONTEXT_ASSISTANT_MESSAGE
} from './actions.type';

import {
  SHOW_CONTEXT_ASSISTANT_MODULE,
  HIDE_CONTEXT_ASSISTANT_MODULE,
  TOGGLE_CONTEXT_ASSISTANT
} from './mutations.type';

const initialState = {
  contextAssistantActive: false,
  contextAssistant: {
    message: '',
    noAction: () => {}
  },
  showContextAssistant: false
};

const state = Object.assign({}, initialState);

const actions = {
  [DISPLAY_CONTEXT_ASSISTANT_MESSAGE](context, payload) {
    state.contextAssistant.message = payload.message || '';
    if (payload.noAction) {
      state.contextAssistant.noAction = payload.noAction;
    }
    context.commit(SHOW_CONTEXT_ASSISTANT_MODULE);
  },
  [HIDE_CONTEXT_ASSISTANT_MESSAGE](context) {
    state.contextAssistant = { message: '', noAction: () => {} };

    context.commit(HIDE_CONTEXT_ASSISTANT_MODULE);
  }
};

const mutations = {
  [SHOW_CONTEXT_ASSISTANT_MODULE](state) {
    state.showContextAssistant = true;
  },
  [HIDE_CONTEXT_ASSISTANT_MODULE](state) {
    state.showContextAssistant = false;
  },
  [TOGGLE_CONTEXT_ASSISTANT](state) {
    state.contextAssistantActive = !state.contextAssistantActive;
  }
};

const getters = {
  contextAssistantActive(state) {
    return state.contextAssistantActive;
  },
  showContextAssistant(state) {
    return state.showContextAssistant;
  },
  contextAssistant(state) {
    return state.contextAssistant;
  },
  contextAssistantMessage(state) {
    return state.contextAssistant.message;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
